// Date helpers for the React app.
//
// Every date in the app is SHOWN and FILTERED in one business time zone,
// whichever country the recruiter opens the app from. This must be the same
// zone as APP_TIME_ZONE in the backend .env, so the list and the filter agree.
//   US Eastern: "America/New_York"   US Central: "America/Chicago"
//   US Pacific: "America/Los_Angeles"   India: "Asia/Kolkata"
export const APP_TIME_ZONE = "America/New_York";

// Short label for the zone, e.g. "EDT" / "EST", shown next to filters.
export function appTimeZoneLabel(date = new Date()) {
    const part = new Intl.DateTimeFormat("en-US", { timeZone: APP_TIME_ZONE, timeZoneName: "short" })
        .formatToParts(date)
        .find((p) => p.type === "timeZoneName");
    return part ? part.value : APP_TIME_ZONE;
}

// "Oct 14, 2026, 7:30 PM"
export function formatDateTime(value) {
    if (!value) return "—";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleString("en-US", {
        timeZone: APP_TIME_ZONE,
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
    });
}

// "Oct 14, 2026"
export function formatDate(value) {
    if (!value) return "—";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("en-US", {
        timeZone: APP_TIME_ZONE,
        year: "numeric",
        month: "short",
        day: "numeric",
    });
}

// Calendar date ("YYYY-MM-DD") of a moment in the business time zone.
export function toAppDateString(value = new Date()) {
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: APP_TIME_ZONE,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).formatToParts(new Date(value));
    const v = Object.fromEntries(parts.map((p) => [p.type, p.value]));
    return `${v.year}-${v.month}-${v.day}`;
}

// Today in the business time zone, as "YYYY-MM-DD".
export function todayInAppTimeZone() {
    return toAppDateString(new Date());
}

// Adds whole days to a "YYYY-MM-DD" string (pure calendar math, no time zone).
export function addDays(dateString, days) {
    const [y, m, d] = dateString.split("-").map(Number);
    const next = new Date(Date.UTC(y, m - 1, d + days));
    return next.toISOString().slice(0, 10);
}

// Quick ranges for the filter. Each returns { startDate, endDate } as
// "YYYY-MM-DD" in the business time zone.
export const DATE_PRESETS = [
    { key: "today", label: "Today", range: (today) => ({ startDate: today, endDate: today }) },
    { key: "yesterday", label: "Yesterday", range: (today) => ({ startDate: addDays(today, -1), endDate: addDays(today, -1) }) },
    { key: "last7", label: "Last 7 days", range: (today) => ({ startDate: addDays(today, -6), endDate: today }) },
    { key: "last30", label: "Last 30 days", range: (today) => ({ startDate: addDays(today, -29), endDate: today }) },
    { key: "thisMonth", label: "This month", range: (today) => ({ startDate: `${today.slice(0, 8)}01`, endDate: today }) },
];
